import React from "react";
import { Trash, X } from "lucide-react";
import Stepper from "./Stepper";
import "./ItemBulkEditor.scss";

interface ItemBulkEditorProps {
  count: number;
  // the selected items' split count (the first one's when they differ), and
  // whether they differ — so the stepper starts from what's there, not 1
  splits: number;
  mixed: boolean;
  // set the split count on every selected item at once — post-share only
  // (bulk splitting only makes sense once there's a roster to split among)
  onSetSplits?: (splits: number) => void;
  // delete them all — pre-share only (items lock once shared)
  onDelete?: () => void;
  onClear: () => void;
}

// Appears while one or more items are checked: bulk-set their split count
// (post-share), or delete them all (pre-share). Only one of the two actions
// is ever offered, depending on which phase we're in.
const ItemBulkEditor: React.FC<ItemBulkEditorProps> = ({
  count,
  splits,
  mixed,
  onSetSplits,
  onDelete,
  onClear,
}) => {
  return (
    <div className="item-bulk-editor">
      <span className="bulk-count">{count} selected</span>
      {onSetSplits && (
        <div className="bulk-splits">
          <span className="bulk-label">Split all{mixed ? " (mixed)" : ""}</span>
          {/* live: each tap sets every selected item to that count */}
          <Stepper value={splits} min={1} onChange={onSetSplits} />
        </div>
      )}
      {onDelete && <Trash className="bulk-delete" onClick={onDelete} />}
      <X className="bulk-clear" onClick={onClear} />
    </div>
  );
};

export default ItemBulkEditor;
